module.exports = __webpack_public_path__ + "static/media/icon_trash_filter.e356968d.svg";